module.exports = "<div class=\"card rw-card\">\r\n  <div class=\"card-img-top\">\r\n    <img\r\n      ng-if=\"$ctrl.thumbnail\"\r\n      ng-src=\"{{$ctrl.thumbnail}}\"\r\n      alt=\"{{$ctrl.name}}\"\r\n    />\r\n    <rw-icon ng-if=\"!$ctrl.thumbnail\"\r\n             size=\"5x\"\r\n             type=\"file-image-o\" />\r\n  </div>\r\n  <ng-transclude></ng-transclude>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-card/rw-card.html
// module id = 1918
// module chunks = 0